import { useServiceAreas } from '@/hooks/useServiceAreas'

export function useServiceAreaById(id: number) {
  const allServiceAreas = useServiceAreas()

  return allServiceAreas.find((serviceArea) => serviceArea.id === id)
}
